export const categoryColor = (section, property = 'primary', shade = 500, defaultColor = '#eee') => props => {
  // let defaultScope = null;
  const scope = props[section];
  if (!scope) {
    // if (props.navigation && props.navigation[section]) {
      // defaultScope = props.navigation[section].id;
    // } else {
      return defaultColor;
    // }
  }
  // const theScope = scope || defaultScope;
  let color = props.theme.palette.categoryScopes[scope] && 
                props.theme.palette.categoryScopes[scope][property][shade];
  if (!color) {
    color = defaultColor;
  }

  return color;
}

export const propColor = (propName = 'color', defaultColor = '#eee') => props => {
  let color = props[propName];
  if (!color) {
    color = defaultColor;
  }
  return color;
}

// Get prop value from styles.
export const propValue = (propName = 'color', defaultValue = '#eee') => props => {
  let value = props[propName];
  if (!value) {
    value = defaultValue;
  }
  return value;
}

function truncate(str, length, appendix = '...') {
  if (!str) {
    return str;
  }

  if (str && str.length <= length) {
    return str;
  }

  let sliced = '';
  for (let i = 0; i < str.length; i++) {
    if (i <= length) {
      sliced += str[i];
    } else if (str[i] !== ' ') {
      sliced += str[i];
    } else {
      break;
    }
  }

  return `${sliced}${appendix}`;
}

const localStorage = (action, ...params) => {
  const ls = {
    get: () => {
      let data = window.localStorage.getItem(...params);
      try {
        data = JSON.parse(data);
      } catch {};
      return data;
    },
    set: () => {
      let [key, value] = params;
      if (typeof value === 'object') {
        try {
          value = JSON.stringify(value);
        } catch {};
      }
      window.localStorage.setItem(key, value);
    },
  };
  return ls[action]();
}

const getVotesList = () => {
  return localStorage('get', 'vts') || '{}';
}

const getVote = (type = 'post', postId) => {
  const votes = getVotesList();
  const typePrefix = type === 'post' ? 'vt' : 'cvt';
  const storageKeyName = `${typePrefix}${postId}`;
  return votes[storageKeyName];
}

const setVote = (type = 'post', postId, value) => {
  const votes = getVotesList();
  const typePrefix = type === 'post' ? 'vt' : 'cvt';
  const storageKeyName = `${typePrefix}${postId}`;

  if (votes[storageKeyName]) {
    return;
  }

  const newVotesList = {...votes, [storageKeyName]: value};
  localStorage('set', 'vts', JSON.stringify(newVotesList));  
}

const removeVote = (type = 'post', postId, value) => {
  const votes = getVotesList();
  const typePrefix = type === 'post' ? 'vt' : 'cvt';
  let storageKeyName = `${typePrefix}${postId}`;
  // console.log(votes, storageKeyName)

  if (!votes[storageKeyName]) {
    return;
  }

  const {[storageKeyName]: keyValue, ...newVotesList} = votes;
  localStorage('set', 'vts', JSON.stringify(newVotesList));  
}

const scrollTo = (selector, offset = 80, ...customParams) => {
  if (!selector) {
    return;
  }
  // console.log(selector)
  const targetElement = document.querySelector(selector);

  if (!targetElement) {
    return;
  }

  // function animate(targetTop, direction) {
  //   window.requestAnimationFrame(() => {
  //     const y = 10 * direction;
  //     window.scrollTo(null, y);
  //     if (y < targetTop) {
  //       animate();
  //     }
  //   });
  // };
  // const targetTop = targetElement.offsetTop || offset;
  // const direction = targetTop > window.pageYOffset ? 1 : -1;
  // animate(targetTop, direction);
  const params = {
    behavior: "smooth",
    block: "start",
    inline: "start",
    ...customParams
  };
  // console.log(params);
  targetElement.scrollIntoView(params);
}

export {
  truncate,
  localStorage,
  getVote,
  setVote,
  removeVote,
  scrollTo
};